export default __webpack_public_path__ + "9bd239f2788d80fc4fa2f1f4b60e957f.png";